import script from "./MiNTNewsTop.vue?vue&type=script&setup=true&lang=js"
export * from "./MiNTNewsTop.vue?vue&type=script&setup=true&lang=js"

import "./MiNTNewsTop.vue?vue&type=style&index=0&id=1806bf39&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1806bf39"]])

export default __exports__